import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';

const EmailPopUp = ({ localData, module }) => {
  const [showPopover, setShowPopover] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailIds, setEmailIds] = useState([]); // <-- this is your form data

  const handleCancel = () => {
    setShowPopover(false);
    setEmailIds([]); // clear selection on cancel if needed
  };

  const handleSelectChange = (selectedOptions) => {
    setEmailIds(selectedOptions || []);
  };

  const handleSubmit = () => {
    setLoading(true);

    const preparedFormData = {
      ...localData,
      emailIds: emailIds.map((e) => e.value).join(';'), // semicolon separated
    };
    // Remove startDate if it's null
    if (preparedFormData.startDate == null) {
      delete preparedFormData.startDate;
    }

    // Remove endDate if it's null
    if (preparedFormData.endDate == null) {
      delete preparedFormData.endDate;
    }

    if (preparedFormData.validUntil == null) {
      delete preparedFormData.validUntil;
    }

    // 🔹 Map module → API function
    const apiMap = {
      Quote: apiServices.sendEmailForQuotePdf,
      SalesOrder: apiServices.sendEmailForSalesOrderPdf,
      Invoice: apiServices.sendEmailForInvoicePdf,
    };

    const apiFunction = apiMap[module]; // normalize module

    if (!apiFunction) {
      toast.error(`No API defined for module: ${module}`, { position: 'top-right' });
      setLoading(false);
      return;
    }

    apiFunction(preparedFormData)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          handleCancel();
          toast.success('Email Sent Successfully!', { position: 'top-right' });
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              errorMessages.push(...response.errors[key]);
            }
          }
          errorMessages.forEach((msg) => toast.error(msg, { position: 'top-right' }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        toast.error('An unexpected error occurred.', { position: 'top-right' });
        setLoading(false);
      });
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      show={showPopover}
      onToggle={() => setShowPopover(!showPopover)}
      overlay={
        <Popover id="popover-basic" className="emailPopover">
          <Popover.Body>
            <CreatableSelect
              name="emailIds"
              isMulti
              placeholder="Enter Email"
              styles={{
                container: (base) => ({
                  ...base,
                  width: '100%',
                }),
                control: (base) => ({
                  ...base,
                  width: '600px',
                }),
              }}
              onChange={handleSelectChange}
              value={emailIds} // <-- use state, not formData
            />
            <div
              className="tagBtn spacing_bt"
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'end',
                gap: '10px',
              }}
            >
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading || emailIds.length === 0}
              >
                {loading && (
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></div>
                )}
                {loading ? 'Loading...' : 'Send'}
              </button>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <button
        className="btn btn-primary"
        onClick={() => setShowPopover(!showPopover)}
      >
        Send Email
      </button>
    </OverlayTrigger>
  );
};

export default EmailPopUp;
